import type { Coord, GridColumn, GridIssues } from './types'

/** Issue cells in row-major order. */
export function issueCells<R>(
  rows: R[],
  columns: GridColumn<R>[],
  rowKey: (row: R) => string,
  issues: GridIssues | undefined,
): Coord[] {
  if (!issues) return []
  const out: Coord[] = []
  rows.forEach((row, r) => {
    const byColumn = issues[rowKey(row)]
    if (!byColumn) return
    columns.forEach((col, c) => {
      if (byColumn[col.id] !== undefined) out.push({ row: r, col: c })
    })
  })
  return out
}

/**
 * F8 / Shift+F8: the next / previous issue cell after `from` (wraps around). No issues = null;
 * `from` null starts before the first cell.
 */
export function nextIssue(cells: Coord[], from: Coord | null, back: boolean): Coord | null {
  if (cells.length === 0) return null
  if (!from) return back ? cells[cells.length - 1]! : cells[0]!
  const after = (c: Coord) => c.row > from.row || (c.row === from.row && c.col > from.col)
  const before = (c: Coord) => c.row < from.row || (c.row === from.row && c.col < from.col)
  if (back) {
    for (let i = cells.length - 1; i >= 0; i--) if (before(cells[i]!)) return cells[i]!
    return cells[cells.length - 1]!
  }
  for (const c of cells) if (after(c)) return c
  return cells[0]!
}
